import { loadScriptAsync } from 'Root/helpers/tools';

const ALTCRAFT_URL = 'https://pxl.ru.altkraft.com/ak_container.js?id=';

export default {
  methods: {
    async loadAltcraftPush() {
      if (typeof window === 'undefined' || window.AKPush instanceof Function) {
        return;
      }

      await loadScriptAsync(`${ALTCRAFT_URL}${process.env.ALTCRAFT_CONTAINER_ID}`);
    },
  },
};
